import { render } from "./UpdateOurPartners.vue?vue&type=template&id=6707d9f8"
import script from "./UpdateOurPartners.vue?vue&type=script&lang=js"
export * from "./UpdateOurPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__